<template>
  <el-dialog
    title="新增报修数据"
    :visible.sync="repairDialog"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :show-close="false"
    width="1200px"
    center>
    <el-form :model="residentForm" :rules="rules" ref="residentForm" label-width="120px">
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="社区：" prop="project">
            <el-input :value="project" readonly placeholder="请输入社区"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="小区：" prop="community">
            <!--            <el-input :value="community" readonly placeholder="请输入小区"></el-input>-->

            <el-select v-model="communityId" placeholder="请选择楼栋" style="width: 100%">
              <el-option
                v-for="item in communityList"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>


          </el-form-item>
        </el-col>
        <el-col :span="12" class="flex align-center">
          <el-row :gutter="10">
            <el-col :span="12">
              <el-form-item class="basis-sm" label="楼门户：" prop="building">
                <el-select v-model="residentForm.building" placeholder="请选择楼栋">
                  <el-option
                    v-for="item in buildingList"
                    :key="item.id"
                    :label="item.building_name"
                    :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item class="basis-xsm" prop="unit" label-width="0">
                <el-select v-model="residentForm.unit" placeholder="请选择单元">
                  <el-option
                    v-for="item in unitList"
                    :key="item.id"
                    :label="item.element_name"
                    :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item class="basis-xsm" prop="room" label-width="0">
                <el-select v-model="residentForm.room" placeholder="请选择房间">
                  <el-option
                    v-for="item in roomList"
                    :key="item.id"
                    :label="item.room_name"
                    :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-col>
        <el-col :span="12">
          <el-form-item label="联系人：" prop="name">
            <el-input v-model="residentForm.name" placeholder="请输入联系人姓名"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="手机号：" prop="phone">
            <el-input v-model="residentForm.phone" placeholder="请输入手机号"></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="报修类型：" prop="baoxiu">
            <el-select v-model="residentForm.baoxiu" class="w-all" placeholder="请选择报修类型">
              <el-option
                v-for="item in baoxiuList"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12" v-if="residentForm.baoxiu === 5">
          <el-form-item label="报修内容：" prop="baoXiuContent">
            <el-input v-model="residentForm.baoXiuContent" placeholder="请输入报修内容"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item class="flex align-center justify-around" label-width="0">
        <el-button class="padding-lr-xl" @click="resetForm('residentForm')">取消</el-button>
        <el-button class="padding-lr-xl" type="primary" @click="submitForm('residentForm')">提交</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
import {getYuanGongGuanLiXiaoQu} from "@/api/login";
import {baoxiuList, optionList} from "@/utils/utils";
import {getDanYuanList, getFangJianList, getLouHaoList} from "@/api/common";
import {addBaoXiu} from "@/api/resident";
import rules from "@/utils/rules";

export default {
  name: "repairDialog",
  props: {
    repairDialog: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      isclear: false,
      project: '',
      projectId: '',
      community: '',
      communityList: [],
      communityId: '',
      buildingList: [],
      unitList: [],
      roomList: [],
      baoxiuList: optionList(false, baoxiuList),

      residentForm: {
        building: '',
        unit: '',
        room: '',
        name: '',
        baoxiu: '',
        phone: '',
        baoXiuContent: '',
      },
      rules: {
        building: [{required: true, message: '请选择楼栋', trigger: 'change'}],
        unit: [{required: true, message: '请选择单元', trigger: 'change'}],
        room: [{required: true, message: '请选择房间号', trigger: 'change'}],
        name: [{required: true, message: '请输入姓名', trigger: 'blur'}],
        phone: rules.phone,
        baoxiu: [{required: true, message: '请选择报修类型', trigger: 'change'}],
        baoXiuContent: [{required: true, message: '请输入报修内容', trigger: 'blur'}],
      }
    }
  },
  created() {
    if (this.user.power === 6) this.getComminity()
  },
  computed: {
    user() {
      return this.$store.state.user
    },
  },
  methods: {
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.$emit('cancelDialog', false)
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.submitData(formName)
        }
      });
    },
    async submitData(formName) {
      let _state = await addBaoXiu(
        this.projectId,
        this.communityId,
        this.residentForm.building,
        this.residentForm.unit,
        this.residentForm.room,
        this.residentForm.name,
        this.residentForm.phone,
        this.residentForm.baoxiu,
        this.residentForm.baoXiuContent,
        '',
      );
      this.$message.success(_state.info);
      this.$refs[formName].resetFields();
      this.$emit("cancelDialog", true);
    },
    //  获取房间
    async getRoom() {
      let _data = await getFangJianList(this.residentForm.unit)
      this.roomList = _data.data
      this.isclear = true
    },
    //  获取单元
    async getUnit() {
      let _data = await getDanYuanList(this.residentForm.building)
      this.unitList = _data.data
    },
    //  获取楼栋
    async getBuild() {
      let _data = await getLouHaoList(this.communityId)
      this.buildingList = _data.data
    },

    //  获取当前员工管理的社区和小区
    async getComminity() {
      let _data = await getYuanGongGuanLiXiaoQu(this.user.id)
      this.project = _data.data.xiangmu_name
      this.projectId = _data.data.xiangmu_id

      let _id = _data.data.xiaoqu_id.split(',').map(Number)
      let _name = _data.data.xiaoqu_name.split(',')
      let _arr = []
      _id.map((item, index) => {
        _arr.push({
          id: item,
          name: _name[index]
        })
      })
      this.communityList = _arr
      this.community = _name[0]
      this.communityId = _id[0]
    }
  },
  watch: {
    communityId() {
      if (this.communityId) {
        this.residentForm.building = ''
        this.residentForm.unit = ''
        this.residentForm.room = ''
        this.getBuild()
      }
    },
    'residentForm.building'() {
      if (this.residentForm.building) {
        this.getUnit()
        if (this.isclear) {
          this.residentForm.unit = ''
          this.residentForm.room = ''
          this.$nextTick(() => {
            this.$refs.residentForm.clearValidate();
          })
        }

      }


    },
    'residentForm.unit'() {
      if (this.residentForm.unit) {
        this.getRoom()
        if (this.isclear) {
          this.residentForm.room = ''
          this.$nextTick(() => {
            this.$refs.residentForm.clearValidate();
          })
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">

</style>
